import * as angular from 'angular';

import { uiDecimalDirective } from './ui-decimal.directive';

export const uiDecimal = angular.module('uiDecimal', [])
	.directive('uiDecimal', uiDecimalDirective)
	.name;
